<template lang="pug">
  div.wrap-module-others.f.fh
    span(@click="logout").cursor-pointer Sign Out

</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-others {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

export default {
  components: {
  },
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      
    }
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    logout () {
      this.signOut()
      setTimeout(() => {
        this.$router.push('/sign-in')
      }, 400)
    },
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    }
  }
}
</script>
